"use strict";
import { RoutingActions } from "nft/types";
function buildRoutingItem(routingItem) {
  return {
    action: RoutingActions.Buy,
    marketplace: routingItem.marketplace.toLowerCase(),
    amountIn: routingItem.price.value,
    assetIn: {
      ETHPrice: routingItem.price.value,
      baseAsset: routingItem.price.currency,
      basePrice: routingItem.price.value,
      baseDecimals: "18"
    },
    amountOut: routingItem.amount.toString(),
    assetOut: {
      id: routingItem.id,
      decimals: 18,
      address: routingItem.contractAddress,
      priceInfo: {
        ETHPrice: routingItem.price.value,
        baseAsset: routingItem.price.currency,
        basePrice: routingItem.price.value,
        baseDecimals: "18"
      },
      tokenType: routingItem.tokenType,
      tokenId: routingItem.tokenId,
      amount: routingItem.amount.toString(),
      marketplace: routingItem.marketplace.toLowerCase(),
      orderSource: "api"
    }
  };
}
function buildRoutingItems(routingItems) {
  return routingItems.map(buildRoutingItem);
}
export function buildRouteResponse(routeResponse, useErc20Token) {
  const route = routeResponse.route ? buildRoutingItems(routeResponse.route) : [];
  return {
    route,
    routeResponse: {
      route,
      valueToSend: useErc20Token ? void 0 : routeResponse.sendAmount.value,
      data: routeResponse.calldata,
      to: routeResponse.toAddress
    }
  };
}
